import styled from 'styled-components';

const StyledDiv = styled.div`
  padding: 13px 0px;
  padding-left: -2px;
  margin-right: 81px;
  font-size: 14px;
  line-height: 18px;
  animation: 0.4s show_alert;
  width: 99.7%;
  display: block;
  border: solid 0px #e2e2e2;
  float: left;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
`;

const AlertStyledDiv = styled(StyledDiv)`
  background: #fff0f0;
  color: #ff3939;
`;

const NarrorAlertStyledDiv = styled(StyledDiv)`
  background: #fff0f0;
  color: #ff3939;
  padding: 1px 0px;
  float: none;
`;

const InfoStyledDiv = styled(StyledDiv)`
  background: #fffee0;
  color: #828282;
`;

interface Props {
  children: any;
}

export const AlertFormDiv = (props: Props) => {
  const { children } = props;
  return <AlertStyledDiv>{children}</AlertStyledDiv>;
};

export const NarrowAlertFormDiv = (props: Props) => {
  const { children } = props;
  return <NarrorAlertStyledDiv>{children}</NarrorAlertStyledDiv>;
};

export const InfoFormDiv = (props: Props) => {
  const { children } = props;
  return <InfoStyledDiv>{children}</InfoStyledDiv>;
};
